const resetToggle = () => {
    return {
        type: 'RESET-TOGGLE',
    }
}

export default resetToggle;